import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: 1,
    emoji: '📨',
    title: 'Kit de Comunicación con Familias',
    value: '$15.000'
  }, {
    number: 2,
    emoji: '📋',
    title: 'Banco de Rúbricas Express',
    value: '$15.000'
  }, {
    number: 3,
    emoji: '📅',
    title: 'Planificador Visual Anual',
    value: '$15.000'
  }, {
    number: 4,
    emoji: '🧭',
    title: 'Protocolos de Intervención',
    value: '$15.000'
  }, {
    number: 5,
    emoji: '📊',
    title: 'Fichas de Seguimiento Individual',
    value: '$15.000'
  }, {
    number: 6,
    emoji: '🗂️',
    title: 'Organizador Docente Digital',
    value: '$15.000'
  }];
  return <section className="w-full bg-transparent py-6" data-id="element-17">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-18">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-19">
          <BookOpenIcon className="w-5 h-5 text-[#C084FC]" data-id="element-20" />
          <h2 className="text-lg md:text-xl font-bold text-white font-['Open_Sans',_sans-serif]" data-id="element-21">
            + 6 Bonos para llevar tu práctica psicopedagógica al siguiente nivel
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2" data-id="element-22">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-[#1A1A1A] border border-[#C084FC]/20 rounded-lg p-3 flex items-start gap-2.5" data-id="element-23">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-24">
                {bonus.emoji}
              </span>
              <div className="min-w-0" data-id="element-25">
                <h3 className="text-xs font-bold text-white leading-tight" data-id="element-26">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-1" data-id="element-27">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-28">
                    {bonus.value}
                  </span>
                  <span className="text-[10px] font-bold text-[#9333EA]" data-id="element-29">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center mt-4" data-id="element-30">
          <div className="border border-[#C084FC]/40 rounded-full px-5 py-2 text-center" data-id="element-31">
            <p className="text-white text-xs md:text-sm font-bold" data-id="element-32">
              Valor total:{' '}
              <span className="line-through text-gray-500" data-id="element-33">$90.000</span>{' '}
              <span className="text-[#9333EA]" data-id="element-34">GRATIS</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}